// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__J6kXa","header":"Form_header__t7Mrq"};